export const analyticsRoutes = {
  label: 'home',
  children: [
    {
      name: 'home',
      icon: 'home',
      to: '/home',
      active: true,
      roles: ['admin', 'principal', 'teacher']
    },
    {
      name: 'dashboard',
      icon: 'chart-pie',
      to: '/dashboard',
      active: true,
      roles: ['admin', 'principal', 'teacher']
    }
  ],
  roles: ['admin', 'principal', 'teacher']
};

export const adminRoutes = {
  label: 'administration',
  children: [
    {
      name: 'schools',
      icon: 'graduation-cap',
      to: '/schools',
      active: true,
      roles: ['admin']
    },
    {
      name: 'users',
      icon: 'users',
      to: '/users',
      active: true,
      roles: ['admin']
    }
  ],
  roles: ['admin']
};

export const operationsRoutes = {
  label: 'operations',
  children: [
    {
      name: 'students',
      icon: 'graduation-cap',
      to: '/students',
      active: true,
      roles: ['admin', 'principal', 'teacher']
    },
    {
      name: 'homework',
      icon: 'file',
      to: '/homework',
      active: true,
      roles: ['admin', 'teacher', 'principal']
    },
    {
      name: 'competitions',
      icon: 'file',
      to: '/competitions',
      active: true,
      roles: ['admin', 'teacher', 'principal']
    },
    {
      name: 'worksheet',
      icon: 'file',
      to: '/worksheet',
      active: true,
      roles: ['admin', 'teacher', 'principal']
    },
    {
      name: 'curriculum',
      icon: 'tasks',
      to: '/curriculum',
      active: true,
      roles: ['admin', 'teacher', 'principal']
    }
  ],
  roles: ['admin', 'principal', 'teacher']
};

export const leaderBoardRoutes = {
  label: 'leaderBoard',
  children: [
    {
      name: 'leaderBoard',
      icon: 'trophy',
      to: '/leaderBoard',
      active: true,
      roles: ['admin', 'principal', 'teacher', 'student']
    }
  ],
  roles: ['admin', 'principal', 'teacher', 'student']
};

export const teachingTools = {
  label: 'Teaching Tools',
  children: [
    {
      name: 'Concept',
      icon: 'home',
      to: '/TeachingTools',
      active: true,
      roles: ['class']
    },
    {
      name: 'Example',
      icon: 'file',
      to: '/example',
      active: true,
      roles: ['class']
    },
    {
      name: 'Activity',
      icon: 'file',
      to: '/activity',
      active: true,
      roles: ['class']
    },
    {
      name: 'Drill & Practice',
      icon: 'chart-pie',
      to: '/dashboard',
      active: true,
      roles: ['class']
    },
    {
      name: 'Unity Game',
      icon: 'gamepad',
      to: '/teaching-tools/unity',
      active: true,
      roles: ['class']
    },
    {
      name: 'Video',
      icon: 'video',
      to: '/video',
      active: true,
      roles: ['class']
    }
  ],
  roles: ['class']
};

export default [
  analyticsRoutes,
  adminRoutes,
  operationsRoutes,
  leaderBoardRoutes,
  teachingTools
];
